import { ExportDownloadCell } from "@/features/exports/components/ExportDownloadCell";
import { ExportDetailCell } from "@/features/exports/components/ExportDetailCell";
import type { ExportJobDetail } from "@/types/api";

/** Compact download + detail row (e.g. Dashboard recent exports). */
export function ExportActionsCell({ job }: { job: ExportJobDetail }) {
  return (
    <div className="action-cell">
      <ExportDownloadCell job={job} />
      <ExportDetailCell job={job} />
    </div>
  );
}
